'use client';

import { useState, useEffect } from 'react';
import FAQCategory from './FAQCategory';
import ContactCTA from './ContactCTA';

interface FAQ {
  id: number;
  question: string;
  answer: string;
}

interface FAQCategoryData {
  id: string;
  title: string;
  icon: string;
  faqs: FAQ[];
}

interface FAQInteractiveProps {
  categories: FAQCategoryData[];
}

const FAQInteractive = ({ categories }: FAQInteractiveProps) => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) {
    return (
      <div data-component-id="src/app/faq/components/FAQInteractive.tsx:33:6" data-component-path="src/app/faq/components/FAQInteractive.tsx" data-component-line="33" data-component-end-line="46" data-component-file="FAQInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22space-y-12%22%7D" className="space-y-12">
        <div data-component-id="src/app/faq/components/FAQInteractive.tsx:34:8" data-component-path="src/app/faq/components/FAQInteractive.tsx" data-component-line="34" data-component-end-line="44" data-component-file="FAQInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22space-y-6%22%7D" className="space-y-6">
          {categories.map((category) => (
            <div data-component-id="src/app/faq/components/FAQInteractive.tsx:36:12" data-component-path="src/app/faq/components/FAQInteractive.tsx" data-component-line="36" data-component-end-line="42" data-component-file="FAQInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" key={category.id} id={category.id}>
              <FAQCategory data-component-id="src/app/faq/components/FAQInteractive.tsx:37:14" data-component-path="src/app/faq/components/FAQInteractive.tsx" data-component-line="37" data-component-end-line="41" data-component-file="FAQInteractive.tsx" data-component-name="FAQCategory" data-component-content="%7B%22elementName%22%3A%22FAQCategory%22%7D"
                title={category.title}
                icon={category.icon}
                faqs={category.faqs}
              />
            </div>
          ))}
        </div>
        <ContactCTA data-component-id="src/app/faq/components/FAQInteractive.tsx:45:8" data-component-path="src/app/faq/components/FAQInteractive.tsx" data-component-line="45" data-component-end-line="45" data-component-file="FAQInteractive.tsx" data-component-name="ContactCTA" data-component-content="%7B%22elementName%22%3A%22ContactCTA%22%7D" />
      </div>
    );
  }

  return (
    <div data-component-id="src/app/faq/components/FAQInteractive.tsx:51:4" data-component-path="src/app/faq/components/FAQInteractive.tsx" data-component-line="51" data-component-end-line="65" data-component-file="FAQInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22space-y-12%22%7D" className="space-y-12">
      <div data-component-id="src/app/faq/components/FAQInteractive.tsx:52:6" data-component-path="src/app/faq/components/FAQInteractive.tsx" data-component-line="52" data-component-end-line="62" data-component-file="FAQInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22space-y-6%22%7D" className="space-y-6">
        {categories.map((category) => (
          <div data-component-id="src/app/faq/components/FAQInteractive.tsx:54:10" data-component-path="src/app/faq/components/FAQInteractive.tsx" data-component-line="54" data-component-end-line="60" data-component-file="FAQInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" key={category.id} id={category.id}>
            <FAQCategory data-component-id="src/app/faq/components/FAQInteractive.tsx:55:12" data-component-path="src/app/faq/components/FAQInteractive.tsx" data-component-line="55" data-component-end-line="59" data-component-file="FAQInteractive.tsx" data-component-name="FAQCategory" data-component-content="%7B%22elementName%22%3A%22FAQCategory%22%7D"
              title={category.title}
              icon={category.icon}
              faqs={category.faqs}
            />
          </div>
        ))}
      </div>

      <ContactCTA data-component-id="src/app/faq/components/FAQInteractive.tsx:64:6" data-component-path="src/app/faq/components/FAQInteractive.tsx" data-component-line="64" data-component-end-line="64" data-component-file="FAQInteractive.tsx" data-component-name="ContactCTA" data-component-content="%7B%22elementName%22%3A%22ContactCTA%22%7D" />
    </div>
  );
};

export default FAQInteractive;